import { FaqSchema } from "@/components/FaqSchema";
import { ContentPageNav } from "@/components/ContentPageNav";
import { Footer } from "@/components/Footer";

const html = `<nav aria-label="Kruimelpad" class="px-3 pt-4 pb-2"><div class="container mx-auto max-w-6xl"><ol class="flex flex-wrap items-center gap-2 text-sm"><li class="flex items-center gap-2"><a href="/" class="text-muted-foreground hover:text-foreground transition-colors">Home</a></li><li class="text-foreground font-medium" aria-current="page">Draaiboek husselavond</li></ol></div></nav>

  <header class="py-10 md:py-20 px-3">
    <div class="container mx-auto max-w-3xl">
      <h1 class="text-3xl md:text-5xl font-bold text-foreground mb-6">Draaiboek husselavond: complete checklist voor organisatoren</h1>
      <p class="text-lg md:text-xl text-muted-foreground leading-relaxed">Een goede <strong>husselavond</strong> staat of valt met voorbereiding. Met dit complete draaiboek heb je als TC, commissielid of husselaar alles bij de hand om een vlekkeloze avond te draaien.</p>
    </div>
  </header>

  <article class="px-3 pb-6">
    <div class="container mx-auto max-w-3xl space-y-8">
      
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">2 weken vooraf</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ul class="list-disc pl-6 space-y-1"><li>Bepaal datum en aantal banen.</li><li>Reserveer de banen in jullie baansysteem.</li><li>Maak een sessie aan in De Hussel App of communiceer de avond via je nieuwsbrief.</li><li>Communiceer richting leden via app/mail.</li></ul></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">1 week vooraf</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ul class="list-disc pl-6 space-y-1"><li>Stuur reminder naar de ledenlijst.</li><li>Check kantine-bezetting (bar, vrijwilliger).</li><li>Tel het aantal aanmeldingen — bij <8 overweeg een extra reminder.</li></ul></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">De dag zelf</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ol class="list-decimal pl-6 space-y-1"><li>Open de baan en check het materiaal (netten, ballen).</li><li>Open de sessie in De Hussel App — laat-aanmelders kunnen nog instromen.</li><li>Begroet leden bij binnenkomst.</li><li>Start de eerste ronde — push-meldingen gaan automatisch.</li><li>Iedere ronde: app deelt automatisch in.</li><li>Na de laatste ronde: napraten in de kantine.</li></ol></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Na afloop</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ul class="list-disc pl-6 space-y-1"><li>Sluit de sessie in de app.</li><li>Bekijk de statistieken: aantal deelnemers, gespeelde rondes.</li><li>Stuur een korte bedankmail (kan automatisch).</li><li>Plan de volgende husselavond.</li></ul></div>
        </section>
        <section>
          <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Veelgemaakte fouten</h2>
          <div class="text-muted-foreground leading-relaxed space-y-4"><ul class="list-disc pl-6 space-y-1"><li><strong>Te weinig banen</strong> voor het aantal aanmeldingen — leden gaan vroeg weg.</li><li><strong>Te lange rondes</strong> — verlies van energie en focus.</li><li><strong>Geen vervangende activiteit</strong> bij regen — communiceer een afgelasting via de app.</li><li><strong>Handmatig blijven indelen</strong> — kost tijd én geeft scheve verdelingen.</li></ul></div>
        </section>
    </div>
  </article>

  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-3xl">
      <div class="p-5 md:p-10 text-center rounded-lg border border-accent/30 bg-accent/10">
        <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-4">Klaar om dit voor je club te automatiseren?</h2>
        <p class="text-lg text-muted-foreground mb-6">De Hussel App regelt aanmelden, indelen en push-meldingen — voor husselen, tossen en racket trekken.</p>
        <a href="/club-register" class="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-accent text-accent-foreground font-medium hover:bg-accent/90 transition-colors">Registreer je club </a>
      </div>
    </div>
  </section>

  
  <section class="py-10 md:py-16 px-3">
    <div class="container mx-auto max-w-4xl">
      <h2 class="text-2xl md:text-3xl font-bold text-foreground mb-6 md:mb-8 text-center">Veelgestelde vragen</h2>
      <div class="space-y-3">
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Hoeveel banen heb ik nodig voor een husselavond?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Reken op 1 baan per 4 spelers. Voor 20 spelers heb je dus minimaal 5 banen nodig, anders rouleren spelers vaak met rust.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Wat doe je bij slecht weer?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Communiceer een afgelasting zo vroeg mogelijk via de app. De Hussel App stuurt een push-melding naar alle aangemelde spelers.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Hoe motiveer je leden om te komen?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Een vast moment (bijv. elke dinsdagavond) creëert routine. Combineer met een gratis kopje koffie of een seizoenscompetitie voor extra motivatie.</div>
    </details>
    <details class="group rounded-lg border border-border bg-card p-4 md:p-5">
      <summary class="flex items-center justify-between gap-3 cursor-pointer list-none">
        <h3 class="text-base md:text-lg font-semibold text-foreground">Werkt dit draaiboek ook voor toss- en racket-trek-avonden?</h3>
        
      </summary>
      <div class="mt-3 text-muted-foreground leading-relaxed">Ja. De principes zijn identiek; gebruik dit draaiboek voor elke vorm van wisselende-partner-avonden.</div>
    </details></div>
    </div>
  </section>`;

const DraaiboekHusselavond = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <ContentPageNav showPricing />
      <div
        className="flex-1 marketing-content"
        dangerouslySetInnerHTML={{ __html: html }}
      />
      <FaqSchema html={html} />
      <Footer />
    </div>
  );
};

export default DraaiboekHusselavond;
